import { createRouter, createWebHistory } from 'vue-router';
import IconList from '../components/IconList.vue';
import Icon from '../components/Icon.vue';
import About from '../views/About.vue';

const routes = [
    {
        path: '/',
        name: 'IconList',
        component: IconList,
    },
    {
        // Route two takes the route parameter "id".
        // The parameter value can be accessed with $route.params.id in the RouteTwo component.
        path: '/:id',
        component: Icon,
        name: 'icon',
    },
    {
        path: '/about',
        component: About,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
